export default (function (pixels) {return "".concat((pixels / 10).toString(), "rem");});